import { db } from "common/config/Firebase"

const ticketsCollection = db.collection('tickets')

const findTicketsUseCase = callback => {
    return ticketsCollection.onSnapshot(callback)
}

export default findTicketsUseCase
